// import {
//     CREATE_TOKEN,
//     CREATE_TOKEN_SUCCESS,
//     CREATE_TOKEN_ERROR,
//     GET_TOKEN,
//     GET_TOKEN_SUCCESS,
//     GET_TOKEN_ERROR,
//     UPDATE_TOKEN,
//     UPDATE_TOKEN_SUCCESS,
//     UPDATE_TOKEN_ERROR,
// } from '../actions';

// const initialState = {
//     loading: false,
//     tokens: [],
//     error: null,
// };

// const tokenReducer = (state = initialState, action) => {
//     switch (action.type) {
//         case CREATE_TOKEN:
//         case GET_TOKEN:
//         case UPDATE_TOKEN:
//             return { ...state, loading: true, error: null };

//         case CREATE_TOKEN_SUCCESS:
//             return { ...state, loading: false, tokens: [...state.tokens, action.payload] };

//         case GET_TOKEN_SUCCESS:
//             return { ...state, loading: false, tokens: action.payload };

//         case UPDATE_TOKEN_SUCCESS:
//             return {
//                 ...state,
//                 loading: false,
//                 tokens: state.tokens.map((token) =>
//                     token.id === action.payload.id ? action.payload : token
//                 ),
//             };

//         case CREATE_TOKEN_ERROR:
//         case GET_TOKEN_ERROR:
//         case UPDATE_TOKEN_ERROR:
//             return { ...state, loading: false, error: action.payload };

//         default:
//             return state;
//     }
// };

// export default tokenReducer;


import {
    CREATE_TOKEN,
    CREATE_TOKEN_SUCCESS,
    CREATE_TOKEN_ERROR,
    GET_TOKEN,
    GET_TOKEN_SUCCESS,
    GET_TOKEN_ERROR,
    UPDATE_TOKEN,
    UPDATE_TOKEN_SUCCESS,
    UPDATE_TOKEN_ERROR,
} from '../actions';

const initialState = {
    loading: false,
    data: [], // Renamed from 'tokens' for consistency
    error: null,
};

const tokenReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_TOKEN:
        case GET_TOKEN:
        case UPDATE_TOKEN:
            return {
                ...state,
                loading: true,
                error: null, // Reset error on new request
            };

        case CREATE_TOKEN_SUCCESS:
            // Do NOT mutate 'data' here: after a GET it holds the raw response
            // object, not an array, so spreading it throws. The view refetches
            // the list (getToken) after create, so just clear the loading flag.
            return {
                ...state,
                loading: false,
            };

        case GET_TOKEN_SUCCESS:
            return {
                ...state,
                loading: false,
                // Store the ApplicationResponse payload body: { data: [...keys], total, totalPages, page, limit }
                data: action.payload?.data ?? action.payload,
            };

        case UPDATE_TOKEN_SUCCESS:
            // Same as CREATE: the view refetches after revoke, so don't touch 'data'.
            return {
                ...state,
                loading: false,
            };

        case CREATE_TOKEN_ERROR:
        case GET_TOKEN_ERROR:
        case UPDATE_TOKEN_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload, // Store error details
            };

        default:
            return state; // Return current state for unrecognized action types
    }
};

export default tokenReducer;

